import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=d9b969d6&scoped=true&"
import script from "./RadioView.vue?vue&type=script&lang=js&"
export * from "./RadioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b969d6",
  null
  
)

export default component.exports